import React from "react";
import { AlertCircle, ExternalLink, MessageCircle } from "lucide-react";
import { usePaymentSettings } from "../../hooks/usePaymentSettings";
import styles from "./ReservationPaymentNotice.module.css";

export function ReservationPaymentNotice() {
  const settings = usePaymentSettings();

  const whatsappLink = settings?.whatsappNumber
    ? `https://wa.me/${settings.whatsappNumber.replace(/\D/g, "")}`
    : undefined;

  return (
    <div className={styles.notice}>
      <p className={styles.noticeText}>
        <AlertCircle size={16} className={styles.noticeIcon} />
        Please complete your payment via Instapay within the next 24 hours
        and send the receipt on WhatsApp. Reservations not paid within 24
        hours will be cancelled.
      </p>
      <div className={styles.noticeActions}>
        {settings?.instapayLink && (
          <a
            href={settings.instapayLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.actionLink}
          >
            <ExternalLink size={16} />
            Pay via Instapay
          </a>
        )}
        {whatsappLink && (
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.actionLink} ${styles.whatsappLink}`}
          >
            <MessageCircle size={16} />
            Contact on WhatsApp
          </a>
        )}
      </div>
    </div>
  );
}